import { render, staticRenderFns } from "./DayWeekCalendar.vue?vue&type=template&id=1c5af3da&scoped=true"
import script from "./DayWeekCalendar.vue?vue&type=script&lang=js"
export * from "./DayWeekCalendar.vue?vue&type=script&lang=js"
import style0 from "./DayWeekCalendar.vue?vue&type=style&index=0&id=1c5af3da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5af3da",
  null
  
)

export default component.exports